import { roundToTwo } from '@/utils/helpers';

export const DEPOSIT_METHOD_TYPE = {
  CREDIT_CARD: 1,
  CASH: 2,
  CRYPTO: 3,
  ONLINE_BANKING: 4,
  TRANSFERS: 5,
};

export const isMethodFeeWaived = method => !!method &&
  method.feeState === 1 &&
  method.feePercentage !== null &&
  method.feePercentage !== undefined &&
  method.feePercentage > 0;

export function getDepositMethodTitle(method) {
  switch (method.type) {
    case DEPOSIT_METHOD_TYPE.ONLINE_BANKING:
      return 'Online Banking';
    case DEPOSIT_METHOD_TYPE.CREDIT_CARD:
      return 'Credit Card';
    case DEPOSIT_METHOD_TYPE.CASH:
      return 'Cash';
    case DEPOSIT_METHOD_TYPE.CRYPTO:
      return method.description || 'USDC';
    case DEPOSIT_METHOD_TYPE.TRANSFERS:
      return 'Bank Transfers';
    default:
      return '';
  }
}

export function getDepositMethodTimeframe(method) {
  switch (method.type) {
    case DEPOSIT_METHOD_TYPE.ONLINE_BANKING:
    case DEPOSIT_METHOD_TYPE.CASH:
    case DEPOSIT_METHOD_TYPE.CREDIT_CARD:
      return 'Instant';
    case DEPOSIT_METHOD_TYPE.TRANSFERS:
    case DEPOSIT_METHOD_TYPE.CRYPTO:
      return 'Time Varies';
    default:
      return '';
  }
}

export function getDepositMethodSubtitle(method) {
  const feePercent = roundToTwo((method.feePercentage || 0) * 100);
  let feeText = 'No Fee';
  if (feePercent) {
    feeText = isMethodFeeWaived(method) ? `<s>${feePercent}% Fee</s> Free` : `${feePercent}% Fee`;
  }
  const timeframe = getDepositMethodTimeframe(method);
  return timeframe ? `${timeframe} • ${feeText}` : feeText;
}

export function buildDepositMethodTabs(methods, {
  allowedTypes = null,
} = {}) {
  const results = [];
  (methods || []).forEach((method) => {
    if (allowedTypes && !allowedTypes.includes(method.type)) {
      return;
    }
    results.push({
      name: method.type,
      title: getDepositMethodTitle(method),
      subtitle: getDepositMethodSubtitle(method),
    });
  });
  return results;
}



// WEBPACK FOOTER //
// ./src/components/wallet/shared/depositMethodTypes.js